import { useEffect, useState } from "react";

export type Order = "asc" | "desc";

export type MetaSchema = {
  page: number;
  pages: number;
  total: number;
};

export type PaginationSchema = {
  page?: number;
  sort?: string;
  limit?: number;
  order?: Order;
};

type usePaginationProps = {
  defaultSort: string;
  defaultPage?: number;
  defaultOrder?: Order;
  defaultLimit?: number;
};

const usePagination = (props: usePaginationProps) => {
  const { defaultPage, defaultSort, defaultOrder, defaultLimit } = props;

  const [sort, setSort] = useState<string>(defaultSort);
  const [page, setPage] = useState<number>(defaultPage ?? 0);
  const [order, setOrder] = useState<Order>(defaultOrder ?? "desc");
  const [limit, setLimit] = useState<number>(defaultLimit ?? 25);

  const [body, setBody] = useState<PaginationSchema>({
    page,
    sort,
    order,
    limit,
  });

  const handleSort = (event: React.MouseEvent<unknown>, key: string) => {
    const isAsc = sort === key && order === "asc";
    const newOrder = isAsc ? "desc" : "asc";

    setSort(key);
    setOrder(newOrder);
  };

  const handleChangePage = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeLimit = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLimit(parseInt(e.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    setBody({ page, sort, order, limit });
  }, [page, sort, order, limit]);

  return {
    // variables
    sort,
    page,
    order,
    limit,
    body,

    // methods
    setBody,
    setPage,
    setSort,
    setOrder,
    setLimit,
    handleSort,
    handleChangePage,
    handleChangeLimit,
  };
};

export default usePagination;
